import { render } from "./PCA.vue?vue&type=template&id=4acdc867&scoped=true"
import script from "./PCA.vue?vue&type=script&lang=js"
export * from "./PCA.vue?vue&type=script&lang=js"

import "./PCA.vue?vue&type=style&index=0&id=4acdc867&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acdc867"]])

export default __exports__